import Input from '../../form/input/Input.react';
import PopupActions from '../../../actions/PopupActions';
import React, {Component} from 'react'

import UserStore from '../../../stores/UserStore';
import NotificationActions from '../../../actions/NotificationActions';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosEndPoints} from '../../../constants/PosConstants';

import PricingTierTable from './PricingTierTable'

class PriceCheck extends React.Component {

    constructor() {
        super();

        this.state = {
            packageSerialNumber : '',
            productName: '',
            flowerEquivalent : '',
            productGrams: '',
            quantity : '',
            price : '',
            pricingDetails : [],
            requestStatus: false,
            loadingSpinner : false
        }

        this.getPriceFromProductID = this.getPriceFromProductID.bind(this)
    }

    getPriceFromProductID() {
        this.setState({
            loadingSpinner : true
        })

        var formData  = UserStore.getApiData();
        formData.PackageSerialNumber = this.state.packageSerialNumber;

        AjaxPromises.POST(PosEndPoints.PRICE_CHECK, formData)
        .then((res) => {
            if(!!res.Result) {
                this.setState({
                        productName : res.Data.ProductName,
                        flowerEquivalent : res.Data.FlowerEquivalent,
                        productGrams : res.Data.ProductGrams,
                        quantity: res.Data.Quantity,
                        price : res.Data.Price,
                        pricingDetails : res.Data.PricingTier.PriceDetails,
                        requestStatus : true,
                        loadingSpinner : false
                    })
            }
            else {
                this.setState({
                    loadingSpinner : false
                })
                NotificationActions.error('Price check failed');
                
            }
        })
    }

    render() {
        return (
            <div className='popup popup__transparent'>
                <div className='popup__content price-check'>

                    <div className='popup-header'>
                        PRICE CHECK

                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='container'>

                        <div className='row'>
                            <div className='col-12'>
                                <Input
                                    className='mt-3'
                                    value={this.state.packageSerialNumber}
                                    placeholder='Package ID'
                                    onChange={packageSerialNumber => { this.setState({ packageSerialNumber }); }}
                                    onKeyDown={(e) => {
                                        if (e.which === 13) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            this.getPriceFromProductID()
                                        }
                                    }} />
                            </div>
                        </div>

                        {this.state.loadingSpinner ?
                            <div className="row">
                                <div className='col-12'>
                                    <i className='fa fa-spinner fa-pulse float-right mt-3' />
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-12'>
                                    <button className='btn btn-green float-right mt-3' onClick={this.getPriceFromProductID}>
                                        Get Price
                                    </button>
                                </div>
                            </div>
                        }
                        
                        {this.state.requestStatus &&
                            <div>
                                <hr />
                                <div className='row '>
                                    <div className ='col-4 offset-2'>
                                        <div className='mb-2'>
                                            {'Product Name : '}
                                        </div>

                                        <div className='mb-2'>
                                            {'Flower Equivalent : '}
                                        </div>
                                        
                                        <div className='mb-2'>
                                            {'Product Grams : '}
                                        </div>

                                        <div className='mb-2'>
                                            {'Quantity : '}
                                        </div>

                                        <div className='mb-2'>
                                            {'Price : '}
                                        </div>
                                    </div>

                                    <div className = 'col-6'>
                                        <div className='mb-2'>
                                            {this.state.productName}
                                        </div>

                                        <div className='mb-2'>
                                            {this.state.flowerEquivalent}
                                        </div>

                                        <div className='mb-2'>
                                            {this.state.productGrams}
                                        </div>

                                        <div className='mb-2'>
                                            {this.state.quantity}
                                        </div>

                                        <div className='mb-2'>
                                            {this.state.price}
                                        </div>
                                    </div>
                                </div>

                                 {(this.state.pricingDetails != null) &&                   
                                    <PricingTierTable
                                        pricingDetails = {this.state.pricingDetails} />
                                 }
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default PriceCheck;



// WEBPACK FOOTER //
// ./ui_src/app/components/popup/price-check/PriceCheck.react.jsx